import { filter, FormControl, FormLabel, Switch } from "@chakra-ui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import PopupWrapper from "../../../../../components/PopupWrapper";
import axios from "axios";
import {
  getAxiosConfig,
  getBase64ImageFromUrl,
  getMinioImage,
} from "../../../../../utils/helpers";
import { set } from "react-hook-form";
import Img from "../../../../../components/Img";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import * as Unicons from "@iconscout/react-unicons";

import { Link } from "react-router-dom";
import Slider from "react-slick";
import { FilterOption } from "../../../../material/material-filter/MaterialFilter";
import MasonaryWrapper from "../../../../../components/MasonaryWrapper";
import ImgOptimized from "../../../../../components/ImgOptimized";
import FilterBar from "../../../../material/material-filter/FilterBar";
import SubFilterBar from "../../../../material/material-filter/SubFilterBar";

// Helper function to get appropriate icon for each tag
const getTagIcon = (tag) => {
  const iconMap = {
    // Work Spaces
    "open-office": "material-symbols:group-work",
    "private-cabin": "material-symbols:business-center",
    // "boss-cabin": "material-symbols:workspace-premium",
    "work-lounge": "material-symbols:chair",

    // Meeting Spaces
    assembly: "material-symbols:groups",
    boardroom: "material-symbols:video-call",
    "brainstorm-room": "material-symbols:lightbulb",
    "breakout-space": "material-symbols:coffee",
    "large-meeting-room": "material-symbols:meeting-room",
    "large-open-meeting-space": "material-symbols:space-dashboard",
    "small-meeting-room": "material-symbols:people",
    "small-open-meeting-space": "material-symbols:group",
    "training-room": "material-symbols:school",

    // Support Spaces
    bar: "material-symbols:wine-bar",
    cafeteria: "material-symbols:restaurant",
    "elevator-lobby": "material-symbols:elevator",
    "games-room": "material-symbols:sports-esports",
    "locker-area": "material-symbols:lock",
    "pantry-area": "material-symbols:kitchen",
    "phone-study-booth": "material-symbols:phone",
    "reception-waiting-area": "material-symbols:desk",
    restroom: "material-symbols:wc",
  };
  return iconMap[tag] || "material-symbols:category";
};

const ImgUploadDesignLib = ({ required, images, setImages, tag }) => {
  const [isCrop, setIsCrop] = useState(false);

  const handleSelect = (image) => {
    // console.log("Form values IMAGES", images.includes(image), [...images, image]);
    // console.log("SELECT IMG", image, images);
    const isPresent =
      images?.length > 0
        ? images.map((i) => i?.split("?")[0]).includes(image?.split("?")[0])
        : false;
    if (isPresent) {
      setImages(
        // images.includes(image)
        images
          .map((i) => i?.split("?")[0])
          .filter((img) => img !== image?.split("?")[0]),

        // : [...images, image]
        true,
      );
    } else {
      setIsCrop(image);
      // setImages([...images, image]);
    }
    return;
    setImages(
      images.includes(image)
        ? images.filter((img) => img !== image)
        : [...images, image],
      images.includes(image),
    );
  };
  function editCrop(image) {
    // console.log("EDIT CROP");
    setIsCrop(image);
  }
  // console.log("SELECTED TAG IMG", tag);
  return (
    <>
      <FormControl isRequired={required}>
        <FormLabel fontSize={"sm"} mb={4}>
          Upload images from Design Library
        </FormLabel>
        <div className="flex  h-60 gap-2">
          <div className="basis-1/3 h-full ">
            <SingleGrid
              handleSelect={handleSelect}
              editCrop={editCrop}
              image={images?.[0]}
              selectedTag={tag}
            />
          </div>
          <div className="grid grid-cols-2 grid-rows-2 gap-2 basis-1/3 h-full">
            {[...Array(4)].map((_, idx) => (
              <div key={idx} className="h-auto">
                <SingleGrid
                  handleSelect={handleSelect}
                  image={images?.[idx + 1]}
                  selectedTag={tag}
                  editCrop={editCrop}
                />
              </div>
            ))}
          </div>
          <div className="basis-1/3 h-full">
            <SingleGrid
              handleSelect={handleSelect}
              image={images?.[5]}
              selectedTag={tag}
              editCrop={editCrop}
            />
          </div>
        </div>
      </FormControl>
      {isCrop && (
        <CropPopup
          key={isCrop}
          onClose={() => setIsCrop(false)}
          image={isCrop}
          images={images}
          handleSubmit={(images, isCropped = false) => {
            // console.log("FINAL CROPPED IMAGES", images);
            setImages(images, false, isCropped);
          }}
        />
      )}
    </>
  );
};

const SingleGrid = ({ handleSelect, image, selectedTag, editCrop }) => {
  const inputRef = useRef(null);
  const [popup, setPopup] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  // const [selectedTag, setSelectedTag] = useState("");
  console.log("SELECTED TAG", image);
  const [loading, setLoading] = useState(false);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [filters, setFilters] = useState({
    zone: [],
    section: [],
    material: [],
  });
  const [subFilters, setSubFilters] = useState({});

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const scrollRef = useRef(null);
  const isLoadingRef = useRef(false);
  const loadMoreTriggerRef = useRef(null);
  const [showCollections, setShowCollections] = useState(false);
  const [allCollections, setAllCollections] = useState([]);
  const [collectionSelected, setCollectionSelected] = useState(null);

  // const [selectCollections, setSelectCollection] = useState(null);
  // const [isShowCollection ,setIsShowCollection] = useState(null);

  const specificTags = [
    // Work Spaces
    "Materials",
    "open-office",
    "private-cabin",
    // "boss-cabin",
    "work-lounge",

    // Meeting Spaces
    "assembly",
    "boardroom",
    "brainstorm-room",
    "breakout-space",
    "large-meeting-room",
    "large-open-meeting-space",
    "small-meeting-room",
    "small-open-meeting-space",
    "training-room",

    // Support Spaces
    "bar",
    "cafeteria",
    "elevator-lobby",
    "games-room",
    "locker-area",
    "pantry-area",
    "phone-study-booth",
    "reception-waiting-area",
    "restroom",
  ];
  const CustomPrevArrow = (props) => (
    <div
      className="slick-arrow custom-prev-arrow right-10"
      onClick={props.onClick}
    >
      <span>
        <Unicons.UilAngleLeft />
      </span>
    </div>
  );

  const CustomNextArrow = (props) => (
    <div className="slick-arrow custom-next-arrow" onClick={props.onClick}>
      <span>
        <Unicons.UilAngleRight />
      </span>
    </div>
  );
  // const handleImageChange = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //         // Handle the file upload logic here
  //         console.log("Selected file:", file);
  //     }
  // }
  async function fetchImages(tag = "", page = 1, isLoadMore = false) {
    // Use the passed tag parameter, fallback to selectedTag if tag is empty string

    const effectiveTag = tag || selectedTag || "";
    try {
      if (!isLoadMore) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      if (effectiveTag == "Materials") {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/material/get-all`,
          getAxiosConfig({
            // ...(filters.zone.length != 0 && { zone: filters.zone.join(",") }),
            // ...(filters.section.length != 0 && {
            //   section: filters.section.join(","),
            // }),
            // ...(filters.material.length != 0 && {
            //   materialType: filters.material.join(","),
            // }),
            search: filters?.search || "",
            materialType:
              filters?.types &&
              Array.isArray(filters?.types) &&
              filters?.types?.length
                ? filters?.types?.join(",")
                : "",
            brand:
              filters?.brands &&
              Array.isArray(filters?.brands) &&
              filters?.brands?.length
                ? filters?.brands?.join(",")
                : "",
            filters: JSON.stringify(subFilters || {}),
          }),
        );

        setFilteredMaterials(data?.data?.collections);
        setImages(
          data?.data?.collections
            .map((v) => v.images)
            .flat()
            .map((v) => getMinioImage(v)),
        );
        console.log(
          "IMAGES",
          filters,
          data?.data?.collections
            .map((v) => v.images)
            .flat()
            .map((v) => getMinioImage(v)),
        );
        setTotalPages(1);
        setCurrentPage(1);
      } else {
        const {
          data: { images: newImages, totalPages: apiTotalPages },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/image/filter?limit=50&page=${page}&isRandom=true`,
          getAxiosConfig({
            tags: effectiveTag,
          }),
        );

        const formattedImages = newImages.map(
          (v) =>
            `https://design-api.airbrickinfra.com/api/minio/static/brick-img/${v?._id}.jpg`,
        );

        if (isLoadMore) {
          setImages((prevImages) => [...prevImages, ...formattedImages]);
        } else {
          setImages(formattedImages);
        }

        setTotalPages(apiTotalPages || 1);
        setCurrentPage(page);
      }
    } catch (error) {
      console.log(error?.message, "FETCHING IMAGES ERROR");
    } finally {
      setLoading(false);
      setLoadingMore(false);
      isLoadingRef.current = false;
    }
  }

  const handleTagSelect = (tag) => {
    const newTag = selectedTag === tag ? "" : tag;
    // Reset pagination when changing tags
    setCurrentPage(1);
    setImages([]);
    fetchImages(newTag, 1, false);
  };

  // Infinite scroll handler with throttling
  const handleScroll = useCallback(() => {
    if (
      !scrollRef.current ||
      isLoadingRef.current ||
      selectedTag === "Materials"
    )
      return;

    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

    // Check if we've reached near the bottom (85% scrolled) - reduced threshold for faster triggering
    if (scrollTop + clientHeight >= scrollHeight * 0.85) {
      loadMoreImages();
    }
  }, [selectedTag]);

  // Throttled scroll handler
  const throttledHandleScroll = useCallback(() => {
    let timeoutId;
    return () => {
      if (timeoutId) return;
      timeoutId = setTimeout(() => {
        handleScroll();
        timeoutId = null;
      }, 100); // 100ms throttle
    };
  }, [handleScroll]);

  const loadMoreImages = useCallback(() => {
    if (
      currentPage < totalPages &&
      !isLoadingRef.current &&
      selectedTag !== "Materials"
    ) {
      isLoadingRef.current = true;
      fetchImages(selectedTag, currentPage + 1, true);
    }
  }, [currentPage, totalPages, selectedTag]);
  // console.log(images);
  useEffect(() => {
    if (popup) {
      setCurrentPage(1);
      fetchImages(selectedTag, 1, false);
    } else {
      setImages([]);
      setCurrentPage(1);
    }
    if (!popup) setSelectedImage(null);
  }, [popup, selectedTag]);

  useEffect(() => {
    console.log("FETCHING MATERIAL");
    setCurrentPage(1);
    fetchImages("Materials", 1, false);
  }, [filters, subFilters]);

  // Add scroll event listener with throttling
  useEffect(() => {
    const scrollElement = scrollRef.current;
    const throttledScroll = throttledHandleScroll();

    if (scrollElement) {
      // Use both scroll and wheel events for better fast scroll detection
      scrollElement.addEventListener("scroll", throttledScroll, {
        passive: true,
      });
      scrollElement.addEventListener("wheel", throttledScroll, {
        passive: true,
      });
      scrollElement.addEventListener("touchmove", throttledScroll, {
        passive: true,
      });

      return () => {
        scrollElement.removeEventListener("scroll", throttledScroll);
        scrollElement.removeEventListener("wheel", throttledScroll);
        scrollElement.removeEventListener("touchmove", throttledScroll);
      };
    }
  }, [throttledHandleScroll]);

  // Intersection Observer for load more trigger (backup method)
  useEffect(() => {
    const triggerElement = loadMoreTriggerRef.current;

    if (triggerElement) {
      const observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (
            entry.isIntersecting &&
            !isLoadingRef.current &&
            selectedTag !== "Materials"
          ) {
            loadMoreImages();
          }
        },
        {
          root: scrollRef.current,
          rootMargin: "100px", // Trigger 100px before the element comes into view
          threshold: 0.1,
        },
      );

      observer.observe(triggerElement);

      return () => {
        observer.unobserve(triggerElement);
        observer.disconnect();
      };
    }
  }, [loadMoreImages, selectedTag]);
  //   useEffect(()=> {
  // fetchImages(selectedTag);
  //   },[selectedTag])

  const handleImageSelect = (image) => {
    setSelectedImage(selectedImage === image ? null : image);
  };

  const handleSelectConfirm = () => {
    if (selectedImage) {
      handleSelect(selectedImage);
      setPopup(false);
      setSelectedImage(null);
    }
  };

  const handleCancel = () => {
    setPopup(false);
    setSelectedImage(null);
    // setSelectedTag("");
    setImages([]);
  };
  let possibleOptions = useMemo(() => {
    return {
      zone: [...new Set(filteredMaterials.map((v) => v.zones).flat())],
      section: [...new Set(filteredMaterials.map((v) => v.sections).flat())],
      materialType: [
        ...new Set(filteredMaterials.map((v) => v.materialType).flat()),
      ],
    };
  }, [filteredMaterials]);

  useEffect(() => {
    async function getCollections() {
      try {
        const {
          data: { data },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/collection/get-all`,
          getAxiosConfig(),
        );
        setAllCollections(
          data.map((c) => ({
            ...c,
            images: (c.images || []).map(
              (i) =>
                "https://design-api.airbrickinfra.com/api/minio/static/brick-img/" +
                i.id +
                ".jpg",
            ),
          })),
        );
      } catch (error) {
        console.log(error);
      }
    }
    getCollections();
  }, []);
  // console.log()
  return (
    <>
      <div className="w-full h-full flex items-center justify-center bg-white rounded-lg border">
        {!image ? (
          <Icon
            icon={"majesticons:plus-line"}
            color="teal"
            width={"60%"}
            onClick={() => setPopup(true)}
          />
        ) : (
          <div className="w-full h-full relative">
            <Img
              src={image}
              width={"100%"}
              height={"100%"}
              className={
                "w-[85%] h-[85%] object-cover rounded-lg mx-auto relative top-1/2 -translate-y-1/2 "
              }
            />
            <Icon
              icon="material-symbols:delete-outline-rounded"
              onClick={() => handleSelect(image)}
              className="absolute top-0 right-0 text-red-500 hover:text-red-700 cursor-pointer text-2xl"
            />
            <Icon
              icon="tabler:edit"
              onClick={() => editCrop(image)}
              className="absolute top-0 left-0 text-yellow-500 hover:text-yellow-700 cursor-pointer text-2xl"
            />
          </div>
        )}
        {/* <input type="file" className='hidden' ref={inputRef} onChange={handleImageChange} /> */}
      </div>
      {popup && (
        <PopupWrapper
          onClose={handleCancel}
          heading={"Select Image"}
          width={"max-w-5xl"}
          handleSubmit={handleSelectConfirm}
          isShowAction={true}
        >
          {/* <div className="flex justify-end items-center gap-3 "> */}
          <div
            className={`flex items-center ${!collectionSelected ? "justify-end" : "justify-between"}`}
          >
            {collectionSelected && (
              <Icon
                onClick={() => {
                  setCollectionSelected(null);
                }}
                icon={"ep:back"}
                width={"28px"}
                className="cursor-pointer "
              />
            )}
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent={"flex-end"}
              width={"fit-content"}
            >
              <FormLabel htmlFor="email-alerts" mb="0" cursor={"pointer"}>
                Show collections
              </FormLabel>
              <Switch
                colorScheme="teal"
                checked={showCollections}
                onChange={() => {
                  setShowCollections(!showCollections);
                  setCollectionSelected(null);
                }}
                id="email-alerts"
              />
            </FormControl>
          </div>

          {/* </div> */}
          {/* Modern Tags Section */}
          <div className="mb-4">
            {/* All Tags Button */}

            {selectedTag == "Materials" && (
              <div className="mt-4 space-y-1 ">
                <FilterBar
                  filter={filters}
                  setFilter={setFilters}
                  isFixed={false}
                  subFilter={subFilters}
                >
                  <SubFilterBar
                    filter={filters}
                    subFilter={subFilters}
                    setSubFilter={setSubFilters}
                    isFixed={false}
                  />
                </FilterBar>
                {/* <FilterOption
                  filters={filters}
                  setFilters={setFilters}
                  options={possibleOptions}
                  notShowAddMaterial={true}
                /> */}
              </div>
            )}
          </div>

          {/* Images Grid */}
          {showCollections ? (
            <div className="h-[60svh] overflow-y-auto mb-4">
              {collectionSelected ? (
                <>
                  {collectionSelected.images.length === 0 ? (
                    <div className="flex items-center justify-center h-64 text-center">
                      <div>
                        <Icon
                          icon="material-symbols:image-not-supported"
                          className="text-gray-400 text-6xl mx-auto mb-4"
                        />
                        <p className="text-gray-500 text-lg">No images found</p>
                        <p className="text-gray-400 text-sm">
                          {selectedTag
                            ? "Try selecting a different category"
                            : "Try selecting a category to filter images"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 p-4">
                      {collectionSelected.images.map((image, index) => (
                        <div
                          key={index}
                          className={`relative cursor-pointer rounded-lg overflow-hidden border-2  transition-all duration-200 ${
                            selectedImage === image
                              ? "border-teal-500 shadow-lg scale-105"
                              : "border-gray-200 hover:border-gray-300"
                          }`}
                          onClick={() => handleImageSelect(image)}
                        >
                          <Img
                            src={image}
                            width="100%"
                            height="100%"
                            alt={`Design ${index + 1}`}
                            className="w-full h-48 object-cover"
                          />
                          {selectedImage === image && (
                            <div className="absolute inset-0 bg-teal-500 bg-opacity-20 flex items-center justify-center">
                              <Icon
                                icon="material-symbols:check-circle"
                                className="text-teal-500 text-2xl"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <MasonaryWrapper>
                  {allCollections.map((c) => (
                    <div
                      onClick={() => setCollectionSelected(c)}
                      className="relative w-full h-full rounded-lg overflow-hidden cursor-pointer"
                    >
                      <Img
                        width={"100%"}
                        height={"100%"}
                        src={
                          c.images[
                            Math.floor(Math.random() * (c.images.length || 0))
                          ]
                        }
                        className="w-full h-full object-cover hover:scale-110 transition-all"
                      />
                      <span className="absolute bottom-0 left-0 text-white  p-2 w-full bg-black/20 backdrop-blur-sm ">
                        {c.name}
                      </span>
                    </div>
                  ))}
                </MasonaryWrapper>
              )}
            </div>
          ) : (
            <div
              ref={scrollRef}
              className="max-h-[50svh] h-full overflow-y-auto mb-4"
            >
              {loading ? (
                <div className="flex items-center justify-center h-64">
                  <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto mb-4"></div>
                    <p className="text-gray-500">Loading images...</p>
                  </div>
                </div>
              ) : images.length === 0 ? (
                <div className="flex items-center justify-center h-64 text-center">
                  <div>
                    <Icon
                      icon="material-symbols:image-not-supported"
                      className="text-gray-400 text-6xl mx-auto mb-4"
                    />
                    <p className="text-gray-500 text-lg">No images found</p>
                    <p className="text-gray-400 text-sm">
                      {selectedTag
                        ? "Try selecting a different category"
                        : "Try selecting a category to filter images"}
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 p-4">
                    {images.map((image, index) => (
                      <div
                        key={index}
                        className={`relative cursor-pointer rounded-lg overflow-hidden border-2  transition-all duration-200 ${
                          selectedImage === image
                            ? "border-teal-500 shadow-lg scale-105"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() => handleImageSelect(image)}
                      >
                        <Img
                          src={image}
                          width="100%"
                          height="100%"
                          alt={`Design ${index + 1}`}
                          className="w-full h-48 object-cover"
                        />
                        {selectedImage === image && (
                          <div className="absolute inset-0 bg-teal-500 bg-opacity-20 flex items-center justify-center">
                            <Icon
                              icon="material-symbols:check-circle"
                              className="text-teal-500 text-2xl"
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Intersection Observer trigger for load more */}
                  {currentPage < totalPages && selectedTag !== "Materials" && (
                    <div ref={loadMoreTriggerRef} className="h-1 w-full" />
                  )}

                  {/* Loading more indicator */}
                  {loadingMore && (
                    <div className="flex items-center justify-center py-4">
                      <div className="text-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500 mx-auto mb-2"></div>
                        <p className="text-gray-500 text-sm">
                          Loading more images...
                        </p>
                      </div>
                    </div>
                  )}

                  {/* End of results indicator */}
                  {currentPage >= totalPages &&
                    images.length > 0 &&
                    selectedTag !== "Materials" && (
                      <div className="flex items-center justify-center py-4">
                        <p className="text-gray-400 text-sm">
                          No more images to load
                        </p>
                      </div>
                    )}
                </>
              )}
            </div>
          )}

          {/* <div className="flex justify-end gap-3 pt-4 border-t">
            <button
              onClick={handleCancel}
              className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSelectConfirm}
              disabled={!selectedImage}
              className={`px-6 py-2 rounded-lg transition-colors ${
                selectedImage
                  ? "bg-teal-500 text-white hover:bg-teal-600"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
            >
              Select
            </button>
          </div> */}
        </PopupWrapper>
      )}
    </>
  );
};

const CropPopup = ({ onClose, image, handleSubmit, images }) => {
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
  });

  const [isCroppedUrl, setIsCroppedUrl] = useState(false);
  useEffect(() => {
    // if(cropConfig){
    if (image && image.includes("crop=")) {
      const params = new URL(image).searchParams;
      const encodedCrop = params.get("crop");
      if (encodedCrop) {
        try {
          const paresedObj = JSON.parse(encodedCrop);

          setCrop(paresedObj);
          setIsCroppedUrl(true);
          return;
        } catch (error) {
          console.log("Error parsing crop config from URL:", error);
        }
      }
    }
  }, [image]);
  console.log(images, "CROP CONFIG");
  return (
    <PopupWrapper
      heading={"Crop Image"}
      isShowAction={true}
      isDisbledSubmit={crop.width == 0 || crop.height == 0}
      handleSubmit={() => {
        if (isCroppedUrl) {
          let ImgsCopy = [...images];
          const index = ImgsCopy.findIndex(
            (img) => img?.split("?")[0] == image?.split("?")[0],
          );
          if (index != -1) {
            ImgsCopy[index] = image?.includes("?size")
              ? image?.split("&crop=")[0] + "&crop=" + JSON.stringify(crop)
              : image?.split("?crop=")[0] + "?crop=" + JSON.stringify(crop);
            handleSubmit(ImgsCopy, true);
            onClose();
            return;
          }
          // handleSubmit([...images ,  image+"&crop="+JSON.stringify(crop)])
        } else {
          handleSubmit([
            ...images,
            (image?.includes("?size") ? image + "&crop=" : image + "?crop=") +
              JSON.stringify(crop),
          ]);
        }
        onClose();
      }}
      onClose={onClose}
      width={"max-w-2xl"}
    >
      <div className="max-h-[70vh] overflow-y-auto overflow-x-hidden ">
        <ReactCrop
          crop={crop}
          onChange={(c, percent) => {
            // console.log(c, percent, "CROPING")
            setCrop(percent);
          }}
        >
          <img src={image} />
        </ReactCrop>

        {/* <div className="mt-8">
  <CroppedPreview imageUrl={image?.split("?crop=")?.[0] + "?crop=" + JSON.stringify(crop)}  />
      
      </div> */}
      </div>
    </PopupWrapper>
  );
};

export const CroppedPreview = ({ imageUrl, isPdf = false }) => {
  const canvasRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isCroppedPreview, setIsCroppedPreview] = useState(false);
  const getCanvas = async () => {
    const params = new URL(imageUrl).searchParams;
    var crop = params.get("crop");
    try {
      crop = JSON.parse(crop);
      setIsCroppedPreview(true);
    } catch (error) {
      crop = {
        unit: "%",
        x: 0,
        y: 0,
        width: 100,
        height: 100,
      };
      console.log("Error parsing crop config from URL:", error);
    }

    if (!crop) {
      crop = {
        unit: "%",
        x: 0,
        y: 0,
        width: 100,
        height: 100,
      };
    }
    const img = new Image();
    img.crossOrigin = "anonymous"; // in case image is from another domain
    img.src = isPdf ? await getBase64ImageFromUrl(imageUrl) : imageUrl;

    img.onload = () => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      // Convert % to px
      const cropX = (crop.x / 100) * img.width;
      const cropY = (crop.y / 100) * img.height;
      const cropWidth = (crop.width / 100) * img.width;
      const cropHeight = (crop.height / 100) * img.height;

      // Resize canvas to match crop size
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      // Draw cropped image onto canvas
      ctx.drawImage(
        img,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight,
      );

      // Get preview URL
      setPreviewUrl(canvas.toDataURL("image/jpeg"));
    };
  };

  useEffect(() => {
    getCanvas();
  }, [imageUrl]);

  return (
    <div className="w-full h-full ">
      <canvas ref={canvasRef} style={{ display: "none" }} />
      {previewUrl && (
        //        <div
        //   className={`w-full h-full hover:scale-105 transition-all bg-center bg-no-repeat`}
        //   style={{
        //     backgroundImage: `url(${previewUrl})`,
        //     backgroundSize: imageUrl.includes("3.6.61.15:8080/api/minio/static")
        //       ? "100% 100%" // stretch to fill
        //       : "cover",    // normal aspect-fill
        //   }}
        //   aria-label="Cropped Preview"
        // />

        <div className="relative w-full h-full  overflow-hidden">
          <ImgOptimized
            src={previewUrl}
            alt="Cropped Preview"
            className={`absolute inset-0 w-full h-full hover:scale-105 transition-transform duration-300 ${
              imageUrl.includes("/api/minio/static") || isCroppedPreview
                ? "object-fill" // stretch
                : "object-cover" // maintain aspect ratio
            }`}
          />
        </div>

        //  <ImgOptimized
        //   src={previewUrl}
        //   alt="Cropped Preview"
        //   className={`w-full h-full ${
        //     imageUrl.includes("3.6.61.15:8080/api/minio/static")
        //       ? "object-contain"
        //       : " object-cover "
        //   } hover:scale-105 transition-all`}
        // style={{ border: "2px solid #000", borderRadius: "8px" }}
        // />
      )}
    </div>
  );
};

export default React.memo(ImgUploadDesignLib);
